// WHAT A VIEWER MAY READ, by role — the client twin of the server's viewRole()
// (backend/server.js). An auditor is read-only by construction (the server
// refuses every write), so for everything that decides what to SHOW it reads
// as an administrator: what the server sends unmasked, the page draws.
// Action gates (buttons that write) keep reading user.role — an auditor must
// never be offered a button the server would refuse.
//
// Operator 2026-10-24: an auditor saw "payment details and proof are visible
// only to the finance user handling this payment" on a task card the server
// had already sent in full — the card's client-side mirror only knew
// 'administrator'. Every read-side mirror of a server visibility rule goes
// through here so the two can never disagree again.
export const viewRole = (user) => (user?.role === 'auditor' ? 'administrator' : user?.role);
